import React, { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { isAuthenticated } from "../services/auth";

interface ProtectedRouteProps {
  children: React.ReactNode;
  redirectTo?: string;
  checkFn?: () => Promise<boolean> | boolean;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({
  children,
  redirectTo = "/",
  checkFn = isAuthenticated,
}) => {
  const [loading, setLoading] = useState(true);
  const [isAllowed, setIsAllowed] = useState(false);

  useEffect(() => {
    const checkAuth = async () => {
      try {
        // Handle both async and sync check functions
        const result = await checkFn();
        setIsAllowed(result);
      } catch (error) {
        console.error("Error checking auth:", error);
        setIsAllowed(false);
      } finally {
        setLoading(false);
      }
    };

    checkAuth();
  }, [checkFn]);

  // Show loading state while checking authentication
  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <p>Loading...</p>
      </div>
    );
  }

  // Redirect if not authenticated
  if (!isAllowed) {
    return <Navigate to={redirectTo} replace />;
  }

  // Render children if authenticated
  return <>{children}</>;
};

export default ProtectedRoute;
